/**
 * Property API Service
 *
 * Handles all property-related API calls:
 * - Get properties
 * - Get property units
 * - Delete property
 * - Bill tenants
 * - Get property details
 * - Get property photos
 */

import {post} from './client';

export const propertiesApi = {

    /**
     * Get all properties for a landlord
     * @param {string} landlordId - Landlord ID
     * @returns {Promise<Object>} List of properties
     */
    getAll: async (landlordId) => {
        return post('pegasus/visionary/property/get/all/properties', {
            landlord_id: landlordId,
        });
    },

    /**
     * Get specific property details
     * @param {Object} propertyData
     * @param {string} propertyData.property_id - Property ID
     * @returns {Promise<Object>} Property details
     */
    getById: async (propertyData) => {
        return post('pegasus/visionary/property/get/Specific/property', propertyData);
    },

    /**
     * Get units for a specific property
     * @param {string} propertyId - Property ID
     * @returns {Promise<Object>} List of units
     */
    getUnits: async (propertyId) => {
        return post('pegasus/visionary/property/getUnits', {
            property_id: propertyId,
        });
    },

    /**
     * Delete a property
     * @param {string} propertyId - Property ID to delete
     * @returns {Promise<Object>} Delete response
     */
    delete: async (propertyId) => {
        return post('pegasus/visionary/property/delete', {
            property_id: propertyId,
        });
    },

    /**
     * Get property photo
     * @param {Object} photoData
     * @param {string} photoData.property_id - Property ID
     * @returns {Promise<Object>} Property photo data
     */
    getPhoto: async (photoData) => {
        return post('pegasus/visionary/property/get/Specific/property/photo', photoData);
    },

    /**
     * Bill all tenants in a property
     * @param {Object} billingData - Billing details
     * @returns {Promise<Object>} Billing response
     */
    billTenants: async (billingData) => {
        return post('pegasus/visionary/property/bill/tenants', billingData);
    },

    /**
     * Get property bill report
     * @param {Object} reportData
     * @param {string} reportData.landlord_id - Landlord ID
     * @returns {Promise<Object>} Bill report
     */
    getBillReport: async (reportData) => {
        return post('pegasus/visionary/property/bill/report', reportData);
    },
};

export default propertiesApi;
